import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  show(e) {
    e.preventDefault();
    
    // If a modal ID is specified in data-modal-id, show that modal
    const modalId = e.currentTarget.dataset.modalId;
    if (modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.remove("hidden");
      }
    } else {
      // Otherwise show this modal
      this.element.classList.remove("hidden");
    }
  }

  hide(e) {
    e.preventDefault();
    this.element.classList.add("hidden");
  }
}
